// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-base-WDgMV {
  width: fit-content;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
  outline: none;
  border: none;
  background-color: white;
  border-radius: var(--radius-lg);
  padding: 0px 16px;
  -webkit-tap-highlight-color: transparent;
}

@media (pointer: fine) {

  .button-base-WDgMV:hover {
    background-color: rgb(241 38 38 / 0.03);
  }
}

.button-base-WDgMV:active {
  background-color: rgb(241 38 38 / 0.06);
}

.button-hidden-ZhdMj {
  display: none;
}

.button-icon-kNeUy {
  cursor: pointer;
  color: var(--accent-color);
  margin-right: 16px;
}

.button-rightIcon-Phu2K {
  cursor: pointer;
  color: var(--accent-color);
  margin-left: 16px;
}

.button-text-FiWqP {
  font-size: 15px;
  font-weight: 500;
  font-family: Roboto;
  color: var(--accent-color);
  user-select: none;
}

.button-disabled-WL_k1 .button-text-FiWqP {
  color: lightgray;
}

.button-disabled-WL_k1.button-base-WDgMV {
  cursor: default;
}

.button-disabled-WL_k1 .button-icon-kNeUy {
  color: lightgray;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/button/button.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;;EAEE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".base {\n  width: fit-content;\n  height: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  white-space: nowrap;\n  user-select: none;\n  outline: none;\n  border: none;\n  background-color: white;\n  border-radius: var(--radius-lg);\n  padding: 0px 16px;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@media (pointer: fine) {\n\n  .base:hover {\n    background-color: rgb(241 38 38 / 0.03);\n  }\n}\n\n.base:active {\n  background-color: rgb(241 38 38 / 0.06);\n}\n\n.hidden {\n  display: none;\n}\n\n.icon {\n  cursor: pointer;\n  color: var(--accent-color);\n  margin-right: 16px;\n}\n\n.rightIcon {\n  cursor: pointer;\n  color: var(--accent-color);\n  margin-left: 16px;\n}\n\n.text {\n  font-size: 15px;\n  font-weight: 500;\n  font-family: Roboto;\n  color: var(--accent-color);\n  user-select: none;\n}\n\n.disabled .text {\n  color: lightgray;\n}\n\n.disabled.base {\n  cursor: default;\n}\n\n.disabled .icon {\n  color: lightgray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `button-base-WDgMV`,
	"hidden": `button-hidden-ZhdMj`,
	"icon": `button-icon-kNeUy`,
	"rightIcon": `button-rightIcon-Phu2K`,
	"text": `button-text-FiWqP`,
	"disabled": `button-disabled-WL_k1`
};
export default ___CSS_LOADER_EXPORT___;
